// extracted by mini-css-extract-plugin
export default {"wrapper":"Dropdown_wrapper__GbANs","button":"Dropdown_button__gXYMs","arrow":"Dropdown_arrow__KXQWQ","isOpened":"Dropdown_isOpened__Iq6fY"};